module.exports = __webpack_public_path__ + "static/media/carta_55.5c7f76e0.jpg";